<template>
  <div class="container" v-loading.fullscreen.lock.body="fullScreenLoading">
    <el-row :gutter="10" v-if="currentDishModel">
      <el-row :gutter="5" class="class-dish">
        <el-col :span="14">
          <el-card v-if="currentDishModel" class="box-card">
            <div slot="header" class="clearfix">
              <h3 class="header-title">
                第<span class="danger-text">{{currentIndex + 1}}</span><span>/{{`${dishModelCount}`}}个碗</span>
                名称:
                {{
                  currentDishModel && currentDishModel.dish_name
                    ? currentDishModel.dish_name
                    : "暂无名称"
                }}
              </h3>
              <el-badge class="mark" :value="currentClassImagesLeft ? currentClassImagesLeft.length : 0">
                <el-tag type="success">总计</el-tag>
              </el-badge>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <el-badge class="mark" :value="deletedImages.length">
                <el-tag type="danger">已纠错</el-tag>
              </el-badge>
              <div class="btn-wrapper-1">
                <span>
                  <el-button
                    type="primary"
                    :disabled="currentIndex < 1"
                    @click="preDishModel"
                    >上一个例图</el-button>
                  <el-button
                    type="primary"
                    :disabled="currentIndex === dishModelCount - 1"
                    @click="nextDishModel"
                    >下一个例图
                  </el-button>
                  <el-button
                    type="success"
                    class="btn-alone"
                    @click="checkFinished">纠错结束</el-button>
                </span>
              </div>
            </div>
            <classDishWrapper :image="currentDishModel" class="class-dish-wrapper"></classDishWrapper>
          </el-card>
          <span v-else>暂无例图!</span>
        </el-col>
        <el-col :span="8">
          <el-card class="delete-card" :body-style="{width: '100%'}">
            <div slot="header" class="clearfix">
              <h3 class="header-title danger-text">回收站</h3>
            </div>
            <div class="image-wrapper-1">
              <div
                class="image-item-wrapper"
                v-for="dish in deletedImages"
                :key="dish.dish_img_uuid"
              >
                <el-popover
                  popper-class="big-img"
                  ref="popover2"
                  placement="top-start"
                  trigger="hover"
                >
                  <img
                    :src="dish.dish_img_url"
                    class="image-item"
                    slot="reference"
                    alt=""
                  />
                  <div class="big-img-wrapper">
                    <el-button
                      type="primary"
                      class="btn"
                      style="position: absolute"
                      @click="unDelete(dish);"
                      >撤回
                    </el-button>
                    <img :src="dish.dish_img_url" alt="" />
                  </div>
                </el-popover>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <h2 class="process-title">
        <!-- // 自查 -->
        <span
          >检查下列图片,如果和上面的例图<span class="strong-text">不相符</span
          >,请点击 图片上的<i class="el-icon-delete danger-text"></i
          >将图片置为纠错状态</span
        >
        <!-- 审查 -->
      </h2>
      <imageCheckWrapperforNewTask
        ref="imageCheckWrapperforNewTask"
        v-if="currentClassImages.length > 0"
        :images="currentClassImagesLeft"
        :current_class_id="currentDishModel.class_id"
        @pageChange="pageChange"
        @delete="handleDelete"
      >
      </imageCheckWrapperforNewTask>
      <h3 class="tip-wrapper" v-else>
        当前例图暂无图片
        <el-button
          type="primary"
          :disabled="currentIndex < 1"
          @click="preDishModel"
          >上一个例图</el-button>
        <el-button
          type="primary"
          :disabled="currentIndex === dishModelCount - 1"
          @click="nextDishModel"
          >下一个例图</el-button>
      </h3>
    </el-row >
    <el-row :gutter="10" v-else> <span>暂无标准例图</span> </el-row>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import filterWrapper from '_c/filterWrapper';
import imageCheckWrapperforNewTask from './imageCheckWrapperforNewTask';
import imageItem from '_c/imageItemForCheck';
import classDishWrapper from '_c/classDishWrapper';

export default {
  name: 'imageCheckBeforeNewTask',
  components: {
    filterWrapper,
    imageCheckWrapperforNewTask,
    imageItem,
    classDishWrapper
  },
  data () {
    return {
      backDataAcc: [],
      currentIndex: 0,
      checkFailReasonShow: false,
      checkFailReason: '',
      detectedData: {},
      isLastPage: false,
      deletedImages: [],
      fullScreenLoading: false
    };
  },
  mounted () {
    this.setSubTitle('新建任务前审查');
    // this.getBackImages();
  },
  methods: {
    ...mapMutations([
      'setBatchTag',
      'emitLoading',
      'removeLoading',
      'setSubTitle',
      'unMark',
      'setSubTitle'
    ]),
    // 保存标记状态到本地
    async checkFinished () {
      if (this.deletedImages.length > 0) {
        this.$message.warning('审核完成, 跳转到标注页面');
        this.emitLoading(500);
        // fix 删除图片数量较多的时候会出现故障
        // 在请求后端的时候出现refer
        this.$router.push({
          name: 'newTaskMark',
          params: {
            imageList: this.deletedImages
          }
          //
        });
      } else {
        this.$message.warning('审核完成, 正在返回');
        this.emitLoading(500);
        this.$router.push({
          name: 'trainTask',
          params: {
            selfCheck: true
          }
        });
      };
      // try {
      //   // 保存
      //   await apiBackDataAccSave({
      //     canteen_id: this.listQuery.canteen.canteen_id,
      //     label_data_list: this.combineAcc,
      //     apiKey: this.apiKey,
      //     date_ts: util.dateToUnixtimestamp(this.listQuery.datetime, 0)
      //   });
      //   this.$message.warning('保存成功, 正在跳转');
      //   this.emitLoading();
      //   if (this.deletedImages.length > 0) {
      //     this.$router.push({
      //       name: 'backDataImageMark',
      //       query: {
      //         imageList: this.deletedImages
      //       }
      //     });
      //   } else {
      //     this.$router.push({
      //       name: 'backDataAcc',
      //       query: {
      //         imageList: this.deletedImages
      //       }
      //     });
      //   }
      //   this.removeLoading(500);
      // } catch (e) {
      // }
    },
    handleDelete (dish_img_uuid) {
      let dish = this.$_.find(this.currentClassImages, function (a) {
        return a.dish_img_uuid === dish_img_uuid;
      });
      this.deletedImages.push(dish);
    },
    pageChange (page, isLastPage) {
      this.isLastPage = isLastPage;
    },
    // async getBackImages () {
    //   this.currentIndex = 0;
    //   this.emitLoading();
    //   this.getBackDataAcc();
    //   try {
    //     let res = await apiGetBackData({
    //       canteenId: this.listQuery.canteen.canteen_id,
    //       dateRange: {
    //         start_ts: util.dateToUnixtimestamp(this.listQuery.datetime, 0),
    //         end_ts: util.dateToUnixtimestamp(this.listQuery.datetime, 1)
    //       }
    //     });
    //     this.detectedData = res;
    //     this.deletedImages = [];
    //     this.removeLoading();
    //   } catch (e) {}
    //   this.removeLoading();
    // },
    unDelete (dish) {
      this.unMark({ dish_img_uuid: dish.dish_img_uuid });
    },
    showCheckFailReasonDialog () {
      this.checkFailReasonShow = true;
    },
    cancelDialog () {
      this.checkFailReason = '';
      this.checkFailReasonShow = false;
    },
    nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    },
    submitMarkedData () {
      this.$alert('标注还未完成, 请继续标注', '', {
        confirmButtonText: '确定'
      });
    }
  },
  computed: {
    ...mapGetters([
      'listQuery',
      'userinfo',
      'checkTextObjList'
    ]),
    // currentModelDeleted () {
    //
    // },
    // 有回测图片的准确率
    discard_img_uuid_list () {
      return this.deletedImages.map(a => a.dish_img_uuid);
    },
    unCheckedList () {
      if (this.$route.params && this.$route.params.data) {
        return this.$route.params.data;
      }
      return [];
    },
    modelList () {
      try {
        return this.unCheckedList.map(a => {
          if (!a.dish_name && a.dish_native_name) {
            a.dish_name = a.dish_native_name + '(碗碟库)';
          }
          return this.$_.pickBy(a, (val, key) => {
            return key !== 'marked_img_list';
          });
        });
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    currentClassImages () {
      if (this.currentDishModel) {
        return this.unCheckedList[this.currentIndex].marked_img_list;
      } else {
        return [];
      }
    },
    currentClassImagesLeft () {
      return this.$_.differenceBy(this.currentClassImages, this.deletedImages);
    },
    apiKey () {
      return this.userinfo().api_key;
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    markedCount () {
      return this.$store.state.markedCount[this.currentDishModel.class_id] || 0;
    },
    dishModelCount () {
      return this.modelList.length || 0;
    },
    currentDishModel () {
      return this.modelList[this.currentIndex];
    },
    batchImageListUnmarked () {
      return this.markedImageList.filter(image => {
        return !image.class_id;
      });
    },
    batchImagesBlongCurrentModel () {
      return this.markedImageList.filter(image => {
        return image.class_id === this.currentDishModel.class_id;
      });
    },
    batchImageListDelete () {
      return this.markedImageList.filter(image => {
        return image.class_id === '-1';
      });
    }
  },
  watch: {
    currentIndex () {
      this.$refs['imageCheckWrapperforNewTask'].formateCurrentPage();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .tip-wrapper {
    display: inline-block;
    width: auto;
    padding: 20px;
    border: 2px solid red;
    border-radius: 20px;
  }
  .unMarked-card {
    height: 100%;
  }
  .header-title {
    display: inline-block;
  }
  .box-card {
    .btn-wrapper-1 {
      display: inline-block;
      margin-top: -10px;
      float: right;
    }
  }
  .btn-wrapper {
    padding-top: 50px;
    width: 80%;
    .btn-wrapper-1 {
      display: inline-block;
      margin-top: -10px;
      float: right;
    }
  }
  /*.image-wrapper {*/
    /*width: 150px;*/
    /*height: 150px;*/
    /*.image-item {*/
      /*width: auto;*/
      /*height: auto;*/
      /*max-width: 100%;*/
      /*max-height: 100%;*/
    /*}*/
    /*.image-item-wrapper {*/
      /*display: inline-block;*/
      /*width: 20px;*/
      /*height: 20px;*/
      /*.image-item {*/
        /*width: auto;*/
        /*height: auto;*/
        /*max-width: 100%;*/
        /*max-height: 100%;*/
      /*}*/
      /*.big-img {*/
        /*.big-img-wrapper {*/
          /*position: relative;*/
          /*.btn {*/
            /*position: absolute;*/
            /*left: 0;*/
            /*top: 0;*/
          /*}*/
        /*}*/
      /*}*/
    /*}*/
  /*}*/
  .class-dish-wrapper {
    width: 200px;
    height: 200px;
  }
  .image-wrapper-1 {
    width: 100%;
    height: 150px;
    .image-item {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
    .image-item-wrapper {
      display: inline-block;
      width: 20px;
      height: 20px;
      .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      .big-img {
        .big-img-wrapper {
          position: relative;
          .btn {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }
  .process-title {
    .strong-text {
      color: #ff0000;
    }
  }
}
</style>
